<div
  [ngClass]="+params.data.originalValue?.[params.colDef.field]?.value !== +params.data[params.colDef.field]? 'edited': ''"
  class="cell-renderer-currency">
  <div>{{ formatThousands(+price, 2) }}</div>
  @if (+params.data.originalValue?.[params.colDef.field]?.value !== +params.data[params.colDef.field] && params.colDef.field !== 'diffGP' && params.colDef.field !== 'nominalGP') {
    <app-icon-backspace-outline
      (click)="onUndoButtonClick()"
      [tooltip]="'Previous Value = ' +params.data.originalValue[params.colDef.field].value">
    </app-icon-backspace-outline>
  }
</div>
